import { Icon } from '@platform/components';
import { isTypeNavigationCard, TypeNavigationCardSkeleton } from '@platform/contentful';
import { Entry } from 'contentful';
import { legacyIconsToNewIcons } from './util/legacy-icons';

const ContentfulNavigationCard = ({
  entry,
}: {
  entry: Entry<TypeNavigationCardSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
}) => {
  if (!entry || !isTypeNavigationCard(entry)) {
    return null;
  }

  const icon = entry.fields.icon && legacyIconsToNewIcons[entry.fields.icon];

  return (
    <a
      className='min-w-0 bg-white sm:min-h-25 shadow rounded-sm grow-0 shrink p-5 transition duration-200 ease-in-out hover:-translate-y-2 hover:shadow-lg text-left'
      href={entry.fields.url}
      target={entry.fields.openInNewTab ? '_blank' : '_self'}
    >
      <h3 className='mb-3 text-left text-xl leading-6 font-semibold items-center [&>svg]:shrink-0 [&>svg]:inline [&>svg]:mr-2'>
        {icon && icon !== 'linked-in' && <Icon type={icon} size='24' />}
        {/* The LinkedIn icon is odd in that you need to render a larger viewbox than expected */}
        {icon === 'linked-in' && <Icon type={icon} size='24' viewbox='0 0 32 32' />}
        <span>{entry.fields.header}</span>
      </h3>
      {entry.fields.description}
      {/* TODO: Revisit when you find examples of these */}
      {/*{entry.fields.image && (
        <img src={entry.fields.image.fields.file?.url} alt={entry.fields.image.fields.title} />
      )}
      {entry.fields.label}*/}
      {/* TODO: Revisit when you find an example of this */}
      {/*{`Has green separator: ${entry.fields.hasGreenSeparator ? 'Yes' : 'no'}`}*/}
    </a>
  );
};

export default ContentfulNavigationCard;
